import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Assinaturas vendidas pela loja (parte do checkout). */
export const subscriptionsRoutes: RouteObject[] = [
  {
    path: 'assinaturas',
    element: <ModuleRoute module="checkout" permission="orders:read" />,
    children: [{ index: true, lazy: async () => ({ Component: (await import('./subscriptions')).SubscriptionsPage }) }],
  },
];
